/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleProxy from '../common/proxy';
import language from '../lang';
import GentleAppState from '../common/appstate';

var GentleServiceSchedule = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

// 하이브리드 앱 분기 체크
const browserInfo = window.navigator.userAgent;
const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');

// 카드 템플릿
GentleServiceSchedule.card = function(data){
    console.log('스케줄버튼',data);
    //20221017
    // GentleUtil.updateSSOToken();

    const dateString = GentleUtil.dateString(data.Date);
    const subject = data.Subject;

    /* 2022-api-스케쥴
        const dateString = GentleUtil.dateString(data.Date);
        const subject = data.Subject;
    */

    let html = `
    <li>
        <span class="time-label">${dateString}</span>
        <h3>${subject}</h3>
    </li>
    `;
    
    const $card = $(html);
    $card.bind('click',function() {
        let Url = GentleAppState.isPc ? language.url.pc.EachSchedule : language.url.mobile.EachSchedule;
        GentleUtil.ssoOpen(Url);
    });
    return $card;
}

// 카드 템플릿
GentleServiceSchedule.cardSeminar = function(data){
    // todo : data bind
    console.log('GentleServiceSchedule.cardSeminar', data.SeminarStart);

    // const {SeminarId} = data;
    // const {Name, SeminarStart, cbSeminarUrl, SeminarEnd} = data;
    // const dateString = GentleUtil.dateStringSeminar(SeminarStart);
    // const endTime = GentleUtil.dateStringSeminar(SeminarEnd);
    // -->
    // 2025.3 세미나 일정 조회
    const {seminarId, name, seminarStart, seminarEnd, cbSeminarUrl} = data;
    const dateString = GentleUtil.dateStringSeminar(seminarStart);
    const endTime = GentleUtil.dateStringSeminar(seminarEnd);

    let html = `
    <li>
        <span class="time-label-no-bg">${dateString} ~ ${endTime}</span>
        <h3>${name}</h3>
    </li>
    `;
    const $card = $(html);
    $card.bind('click',function() {
        // let url = GentleAppState.isPc ? language.url.pc.EachSeminar : language.url.mobile.EachSeminar;
        // url = url.GentleFormat({seminarId});
        // console.log('최종 url >>>', url)
        // -->
        // 2025.3 세미나 일정 조회
        isHybrid ? window.open(cbSeminarUrl, '_self') 
            : GentleAppState.isPc ? window.open(cbSeminarUrl) : window.location.href = cbSeminarUrl
        }
    );
    return $card;
}

GentleServiceSchedule.seminar = function(json){
    // 오늘 포함 +30일 간의 나의 스케줄 리스트 출력

    const component =  Object.create(this);

    const cards = [];

    // api
    const request = function(PageNo, PageSize, StartDate, EndDate){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.status){
            case 1:
                console.log('data>', data);    
                render(data.data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {PageNo, PageSize, StartDate, EndDate};

        // 2025.3 세미나 일정 조회
        // proxy.request("seminar", param, onSuccess, onFailed );
        // --> 2025.3 수정
        proxy.request("2025-seminar", param, onSuccess, onFailed);
    }

    // 한달전 구하기
    var d = new Date();
    var monthOfYear = d.getMonth();
    d.setMonth(monthOfYear + 1);

    const EndDate = GentleUtil.timeToString(d);
    const StartDate = GentleUtil.todayString(); // 
    
    request(1, 10, StartDate, EndDate );

    const render = function(array){        
        console.log('render', array);
        // 봇버블
        {
            const name = GentleAppState.custName;
            let html = GentleLang.translateService(language.schedule, language.schedule.type.SeminarBot, {name});

            if(array.length == 0){
                html = '세미나 일정이 없어요.'; // todo : 
            }

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 카드
        {
            let button_title = GentleLang.translateService(language.schedule, language.schedule.type.SeminarApply);

            let html = `
            <div class="card-view">
                <ul class="notice" name="list">
                </ul>
                <div class="gentle-button-group" style="margin:10px">
                    <div class="wide-button">
                        <button type="button" class="primary default">${button_title}</button>
                    </div>
                </div>
            </div>`;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("schedule");
                component.init($container);
                component.insert();
            }

            // button 쿼리수정
            component.find('button').bind('click',function() {
                    isHybrid ? window.open(url, '_self') 
                    : GentleAppState.isPc ? window.open(language.url.pc.ApplySeminar) : window.location.href = language.url.mobile.ApplySeminar
                }
            );

            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                
                const $card = GentleServiceSchedule.cardSeminar(element);
                cards.push($card);
        
                $card.find('div').bind('click', function(){
                });
        
                component.find('[name="list"]').append($card);
            }
        }

        // button
        {
            let text = GentleLang.translateService(language.schedule, language.schedule.type.My);
            const html = text;

            const option = [
                {
                    isCardWidth: true,
                    isSecondary: true,
                    text,
                    user: 'user',
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        GentleUtil.timeStamp();
    };
}

GentleServiceSchedule.main = function(json){
    console.log("language.url>>>", language.url)

    // 오늘 포함 +30일 간의 나의 스케줄 리스트 출력

    const component =  Object.create(this);

    const cards = [];

    // api
    const request = function(PageNo, PageSize, StartDate, EndDate){
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;    
                const {Data} = item;
                render(Data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const StartDs = StartDate
        const EndDs = EndDate
        const param = {StartDate, EndDate, PageNo, PageSize};

        // proxy.request("global-schedule", param, onSuccess, onFailed );
        proxy.request("2025-schedule", param, onSuccess, onFailed );
    }

    // 한달전 구하기
    var d = new Date();//현재 시각
    var futd = new Date();
    var oneMonthLater = new Date(futd.setMonth(futd.getMonth() + 1));	// 한달 후
    const StartDate = GentleUtil.dateStringSchedule(d);
    const EndDate = GentleUtil.dateStringSchedule(oneMonthLater) // 
    
    request(1, 10, StartDate, EndDate );

    const render = function(array){
        // 봇버블
        let html;
        {
            if(GentleAppState.isLogin){
                const name = GentleAppState.custName;
                html = GentleLang.translateService(language.schedule, language.schedule.type.Bot, {name});
            }else{
                html = GentleLang.translateService(language.schedule, language.schedule.type.NoLoginBot);
            }

            if(array.length == 0){
                html = GentleLang.translateService(language.schedule, language.schedule.type.NotFoundSchedule);  // todo : 
            }

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            let text = GentleLang.translateService(language.schedule, language.schedule.type.Seminar); //세미나 일정보기

            // let handler = function () {
            //     console.log('세미나 일정보기');
            //     GentleServiceSchedule.seminar(json); // 세미나일정 보기
            // };

            const option = [
                {
                    isCardWidth: true,
                    isSecondary: true,
                    text: text,
                    user: 'user',
                    // onClick: function () {
                    //     console.log('세미나일정 보기');
                    //     GentleServiceSchedule.seminar();
                    // },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        GentleUtil.timeStamp();
    };
}

export default GentleServiceSchedule;